import React, { useMemo } from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { PR_MUNICIPALITIES_ASCII } from "../../utils/prMunicipality";

const municipalitySet = new Set(PR_MUNICIPALITIES_ASCII);

/**
 * PR municipio dropdown: 78 canonical ASCII Title Case options (A–Z) plus optional legacy value.
 */
export function PuertoRicoMunicipalitySelect({
  value,
  onChange,
  name,
  onBlur,
  className,
  disabled,
  placeholder = "Municipio",
  inputComponent,
  inputProps = {},
}) {
  const v = value == null ? "" : String(value);
  const showUnknown = v !== "" && !municipalitySet.has(v);

  const menuItems = useMemo(
    () =>
      PR_MUNICIPALITIES_ASCII.map((m) => (
        <MenuItem key={m} value={m}>
          {m}
        </MenuItem>
      )),
    []
  );

  return (
    <Select
      displayEmpty
      native={false}
      name={name}
      value={v}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      className={className}
      disabled={disabled}
      input={inputComponent}
      inputProps={inputProps}
    >
      <MenuItem value="">
        <em>{placeholder}</em>
      </MenuItem>
      {showUnknown ? (
        <MenuItem key={`legacy-${v}`} value={v}>
          {v}
        </MenuItem>
      ) : null}
      {menuItems}
    </Select>
  );
}
